let infoPage = {
  hide: false,
  cssStyle: {
    primaryColor: '#f15a2f', //to koniecznie
    'font-family': 'Celias',
  },
  people: [
    {
      title: 'MULTIBOOK',
      // name: 'Ćwiczenia interaktywne zostały przygotowane na podstawie publikacji Biologia 6. Zeszyt ćwiczeń autorstwa Karoliny Archackiej, Magdaleny Kosackiej i Ilony Żeber-Dzikowskiej.',
      hideLine: true,
      tcssStyle: { 'font-weight': 'bold' },
    },
    {
      title: 'Koordynator projektu',
      name: '<i>Małgorzata Różańska-Foks</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Redakcja merytoryczna',
      name: '<i>Elżbieta Berezecka</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Opracowanie graficzne',
      name: '<i>Tomasz Kozłowski</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
    {
      title: 'Opracowanie multimedialne',
      name: '<i>Grzegorz Wrzecionowski, Artur Syrek, Mateusz Zamaryka, Michał Guzy, Paweł&nbsp;Sala</i>',
      ncssStyle: { 'font-weight': 'normal' },
    },
  ],
  texts: [
    {
      text: '<b>© Wydawnictwo JUKA-91, Warszawa 2024</b>',
    },
    {
      text: '<div style="text-align:justify;text-justify:inter-word">Wszystkie prawa autorskie i&nbsp;prawa producenta do&nbsp;nagranych utworów zastrzeżone. Kopiowanie, wynajmowanie, wypożyczanie, wykorzystywanie tego nośnika do&nbsp;wykonań publicznych i&nbsp;nadań RTV bez&nbsp;zezwolenia zabronione.</div>',
    },
    // {
    //   text: '<div style="text-align:justify;text-justify:inter-word">Powyższe zastrzeżenie nie obejmuje utworów udostępnionych na&nbsp;licencji Creative Commons oraz&nbsp;korzystania z&nbsp;utworów w&nbsp;zakresie dozwolonego użytku, który określają przepisy prawa.</div>',
    // },
    {
      text: '<div style="text-align:justify;text-justify:inter-word">Wydawca oświadcza, że dołożył wszelkich starań, aby dotrzeć do&nbsp;wszystkich właścicieli i&nbsp;dysponentów praw autorskich. Osoby, których nie udało nam się ustalić, prosimy o kontakt z&nbsp;wydawnictwem.</div>',
    },
    {
      text: 'Wydawnictwo JUKA-91 Sp. z&nbsp;o.o.<br>ul. Jutrzenki 118<br>02-230 Warszawa<br>tel. 41 366 55 55',
    },
    {
      text: '<br><strong><h4>Wykaz dysponentów praw autorskich w&nbsp;multibooku</h4></strong>',
    },

    {
      text: '<strong>Lista nagrań</strong>',
    },
    {
      text: `
      <table style="width:100%;text-align:justify">
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'1';padding-inline-start:1rem">Fun Time</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'26';padding-inline-start:1rem">Story 7. Picnic</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'2';margin-bottom:0;padding-inline-start:1rem">Hello!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'27';margin-bottom:0;padding-inline-start:1rem">A Pepper Is Green</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'3';margin-bottom:0;padding-inline-start:1rem">Bye-bye Song</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'28';margin-bottom:0;padding-inline-start:1rem">What Is It?</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'4';margin-bottom:0;padding-inline-start:1rem">Fun Time Rhyme</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'29';margin-bottom:0;padding-inline-start:1rem">Story 8. I Love Pets</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'5';margin-bottom:0;padding-inline-start:1rem">Table Time Rhyme</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'30';margin-bottom:0;padding-inline-start:1rem">Hey, Hey!</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'6';margin-bottom:0;padding-inline-start:1rem">Let's Move!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'31';margin-bottom:0;padding-inline-start:1rem">I've Got One Head</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'7';margin-bottom:0;padding-inline-start:1rem">I'm Dusty!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'32';margin-bottom:0;padding-inline-start:1rem">Story 9. Let's Dance!</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'8';margin-bottom:0;padding-inline-start:1rem">Story 1. Hello Lisa!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'33';margin-bottom:0;padding-inline-start:1rem">Look at Me!</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'9';margin-bottom:0;padding-inline-start:1rem">Look!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'34';margin-bottom:0;padding-inline-start:1rem">A Yellow Hat</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'10';margin-bottom:0;padding-inline-start:1rem">It's Blue!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'35';margin-bottom:0;padding-inline-start:1rem">Story 10. Fashion Show</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'11';margin-bottom:0;padding-inline-start:1rem">Story 2. Colours</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'36';margin-bottom:0;padding-inline-start:1rem">Yes! You!</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'12';margin-bottom:0;padding-inline-start:1rem">Yika, yika</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'37';margin-bottom:0;padding-inline-start:1rem">Baubles, Bells and Stars</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'13';margin-bottom:0;padding-inline-start:1rem">My Emotions</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'38';margin-bottom:0;padding-inline-start:1rem">Carnival Dance</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'14';margin-bottom:0;padding-inline-start:1rem">Story 3. I'm hungry!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'39';margin-bottom:0;padding-inline-start:1rem">My Pizza</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'15';margin-bottom:0;padding-inline-start:1rem">How Are You?</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'40';margin-bottom:0;padding-inline-start:1rem">Easter Is Fun</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'16';margin-bottom:0;padding-inline-start:1rem">It's My Mummy!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'41';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U1</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'17';margin-bottom:0;padding-inline-start:1rem">Story 4. Help me!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'42';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U2</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'18';margin-bottom:0;padding-inline-start:1rem">Yoo-hoo!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'43';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U3</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'19';margin-bottom:0;padding-inline-start:1rem">My Toys</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'44';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U4</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'20';margin-bottom:0;padding-inline-start:1rem">Story 5. My Cars</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'45';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U5</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'21';margin-bottom:0;padding-inline-start:1rem">One, Two, Three</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'46';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U6</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'22';margin-bottom:0;padding-inline-start:1rem">Clap, Clap, Clap!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'47';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U7</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'23';margin-bottom:0;padding-inline-start:1rem">Story 6. Talent how</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'48';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U8</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'24';margin-bottom:0;padding-inline-start:1rem">Catch the Ball</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'49';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U9</li></ul></td>
      </tr>
      <tr>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'25';margin-bottom:0;padding-inline-start:1rem">It's a Pear!</li></ul></td>
        <td style="text-align:justify;text-justify:inter-word"><ul style="margin:0"><li style="list-style-type:'50';margin-bottom:0;padding-inline-start:1rem">Picture Dictionary U10</li></ul></td>
      </tr>
`,
    },
    {
      text: '<b>Słowa:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Muzyka i aranżacja:</b> Stefan Gąsieniec',
    },
    {
      text: `<div style="text-align:justify;text-justify:inter-word"><b>Wykonawcy:</b> Konstancja Dangel – 22, 24, 25, 28, 30, 31, 34, 36, 37, 38, 40, 51, 52, 53, 54; Andy Edwins – 2, 4, 7, 8, 11, 12, 14, 15, 17, 18, 20, 23, 24, 26, 27, 29, 30, 32, 33, 35, 36, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50; Juliette Edwins – 2, 4, 5, 7, 13, 15, 18, 19, 21; Mateusz Gudelis – 2, 3, 7, 8, 10, 11, 13, 16, 17, 19, 20, 22, 23, 25, 26, 28, 29, 32, 34, 35, 37, 38, 39, 40; Agnieszka Kaczmarek – 1; Amy Routledge – 2, 8, 11, 12, 14, 17, 20, 27, 33</div>`,
    },
    {
      text: '<b>Nagrania zrealizowano w:</b> Altberg Studio Stefan Gąsieniec',
    },
    {
      text: '<b>Reżyseria nagrań i&nbsp;mastering:</b> Stefan Gąsieniec',
    },
    {
      text: 'Error.wav Autistic Lucario CC-BY 4.0 https://freesound.org/people/Autistic%20Lucario/sounds/142608/<br /><br />',
    },
    {
      text: '<strong>Plakaty</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra',
    },
    {
      text: '<strong><br />Karty pracy</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra, Agnieszka Suszczyńska – kontur pod&nbsp;folię',
    },
    {
      text: '<strong><br />Karty obrazkowe</strong>',
    },
    {
      text: '<b>Autorka:</b> Katarzyna Kozłowska',
    },
    {
      text: '<b>Ilustracje:</b> Wojciech Stachyra',
    },
  ],
};
module.exports = infoPage;
